/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { NoteTreeState } from './types'

export const initialState: NoteTreeState = {
  loaded: false,
  entries: {},
  sidebarOpen: true
}
